export { default as FaqLandingStyle } from './FaqLanding.module.scss';
